import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

//conv dd/mm/yyyy to timestamp

export function validPlateWithRegionCd(control: FormControl, zoneCdLookup: any) {
    // let leapyear = control.value;
    // let day, month, year;
    // if (leapyear) {
    //     [day, month, year] = leapyear.split('/').map(e => parseInt(e));
    //     if (day && month && year) {
    //         //check if 18y old
    //         var today = new Date();
    //         var age = today.getFullYear() - year;

    //         if (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0))
    //             return {
    //                 leapyear: 'leap'
    //             }
    //     }
    // }
    console.log('zoneCdLookup',zoneCdLookup);
    return null;
}

@Directive({
    selector: '[validPlateWithRegionCd][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: validPlateWithRegionCd,
            multi: true
        }
    ]
})
export class ValidPlateWithRegionCd {
}